<nb-card>
    <nb-card-header class="header d-flex align-items-center justify-content-start">
        <morva-icons icon="close" class="px-2 cursor-pointer" (click)="closeDialog()"></morva-icons>
        تایید شماره موبایل
    </nb-card-header>
    <nb-card-body>
        <tart-two-factor-authentication [confirmationOTP]="confirmationOTP"
                                        [phoneNumber]="temporaryPhoneNumber?.showValue"
                                        (verifyOTPEmitter)="verifyPhoneNumberOTP($event)"
                                        (resendOTPEmitter)="resendPhoneNumberOTP()"></tart-two-factor-authentication>
    </nb-card-body>
</nb-card>